 export class AddTrainingsModel {
  id: number;
  competencyId: number;
  subCompetencyId: number;
  serviceLineId: number;
  competencySubCompetencyId:number
  typeId: number;
  trainingName: string;
  trainerId: number;
  trainerName : string;
  trainingModeId:number
  locationId: number;
  startDate: string;
  endDate: string;
  attendeeEmails: string[];
  plannedResourcesCount: number;
  prerequisiteTools: string;
  trainingRecordingSharePointURL: string;
}
